/* ===== TRKVLT — pack cards play the whole tracklist =====

   Beat-pack cards used to play a single preview clip from the product's
   custom.audio_url metafield. This queues the pack's ENTIRE tracklist into the
   global player instead, so a card behaves the way the product page does.

   IMPORTANT: cards call window.trkvltPlayPack(el) directly — a name only this
   file defines. Earlier versions overrode window.playPackPreview, which
   global-player.js also defines, and the two kept racing depending on script
   order and AJAX navigation. The dedicated name removes that entirely.
   playPackPreview and handleRecoPlayClick are still overridden below so any
   markup that still calls them behaves the same way.

   Tracklists come from the card's data-tracks attribute when present
   (cart recommendations), otherwise they're read once from the pack's product
   page and cached. Falls back to the single sample if a pack has no tracklist.
*/
(function () {
  'use strict';

  var cache = {};

  var PLAY_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z"/></svg>';
  var PAUSE_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';

  function previewParams() {
    try {
      var q = new URLSearchParams(window.location.search);
      var out = [];
      ['preview_theme_id', '_ab', '_fd', '_sc', 'key'].forEach(function (k) {
        var v = q.get(k);
        if (v) { out.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }
      });
      return out.join('&');
    } catch (e) { return ''; }
  }

  function withPreview(url) {
    var extra = previewParams();
    if (!extra) { return url; }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + extra;
  }

  function cardOf(el) {
    return el.closest('.bp-card') || el.closest('.cart-reco-item');
  }

  function packUrlFromCard(card, morphEl) {
    if (!card) { return ''; }
    if (card.dataset && card.dataset.productUrl) { return card.dataset.productUrl; }
    var viewBtn = card.querySelector('.view-btn, a[href*="/products/"]');
    if (viewBtn) { return viewBtn.getAttribute('href') || ''; }
    if (morphEl && morphEl.dataset && morphEl.dataset.productUrl) { return morphEl.dataset.productUrl; }
    return '';
  }

  function packMetaFromCard(card, morphEl) {
    var img = card ? card.querySelector('img') : null;
    var titleEl = card ? card.querySelector('.bp-name, .bp-title, .cart-reco-title, h3') : null;
    return {
      title: (card && card.dataset && card.dataset.title) || (titleEl ? titleEl.textContent.trim() : ''),
      artwork: (card && card.dataset && card.dataset.image) || (img ? img.src : ''),
      productId: Number(card && card.dataset ? card.dataset.productId : 0) || 0,
      productUrl: packUrlFromCard(card, morphEl),
      variantId: Number(card && card.dataset ? card.dataset.variantId : 0) || 0,
      price: (card && card.dataset ? card.dataset.price : '') || ''
    };
  }

  function tracksFromCard(card) {
    if (!card || !card.dataset || !card.dataset.tracks) { return []; }
    try {
      var parsed = JSON.parse(card.dataset.tracks);
      return Array.isArray(parsed) ? parsed.filter(function (t) { return t && t.url; }) : [];
    } catch (e) { return []; }
  }

  function fetchTracklist(url) {
    if (cache[url]) { return Promise.resolve(cache[url]); }
    return fetch(withPreview(url), { headers: { 'X-Requested-With': 'trkvlt-tracklist' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { return []; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = Array.prototype.slice.call(doc.querySelectorAll('.pd-track'));
        var tracks = rows.map(function (r) {
          return { name: r.getAttribute('data-track-name') || '', url: r.getAttribute('data-track-url') || '' };
        }).filter(function (t) { return t.url; });
        if (tracks.length) { cache[url] = tracks; }
        return tracks;
      })
      .catch(function () { return []; });
  }

  function queueFrom(tracks, meta, key) {
    return tracks.map(function (t) {
      return {
        name: t.name,
        url: t.url,
        packTitle: meta.title || '',
        artwork: meta.artwork,
        productId: meta.productId,
        productUrl: meta.productUrl,
        variantId: meta.variantId,
        price: meta.price,
        packUrlKey: key
      };
    });
  }

  function playSingleFallback(sampleUrl, meta, key) {
    var P = window.TRKVLTPlayer;
    if (!sampleUrl || !P) { return; }
    var track = {
      name: meta.title || 'Preview',
      url: sampleUrl,
      packTitle: meta.title || '',
      artwork: meta.artwork,
      productId: meta.productId,
      productUrl: meta.productUrl,
      variantId: meta.variantId,
      price: meta.price,
      packUrlKey: key
    };
    P.playTrack(track, [track], 0);
  }

  function playPack(card, morphEl, sampleUrl) {
    var P = window.TRKVLTPlayer;
    if (!P) { return; }

    var meta = packMetaFromCard(card, morphEl);
    var key = meta.productUrl || String(meta.productId);

    var current = P.queue[P.currentIndex];
    if (P.hasStarted && current && current.packUrlKey && current.packUrlKey === key) {
      P.togglePlay();
      return;
    }

    var inline = tracksFromCard(card);
    if (inline.length) {
      var q = queueFrom(inline, meta, key);
      P.playTrack(q[0], q, 0);
      return;
    }

    if (!meta.productUrl) { playSingleFallback(sampleUrl, meta, key); return; }

    fetchTracklist(meta.productUrl).then(function (tracks) {
      if (!tracks.length) { playSingleFallback(sampleUrl, meta, key); return; }
      var queue = queueFrom(tracks, meta, key);
      P.playTrack(queue[0], queue, 0);
    });
  }

  /* ---------- public entry point used by card markup ---------- */

  window.trkvltPlayPack = function (el) {
    if (!el) { return; }
    playPack(cardOf(el), el, el.dataset ? el.dataset.sample : '');
  };

  /* ---------- morph button visual state ---------- */

  function setMorphState(morph, state) {
    var pi = morph.querySelector('.bp-play-icon');
    var eq = morph.querySelector('.bp-eq');
    var sw = morph.querySelector('.bp-sweep');
    if (state === 'playing') {
      morph.classList.add('expanded');
      if (pi) { pi.innerHTML = PAUSE_SVG; pi.style.opacity = '1'; }
      if (eq) { eq.style.opacity = '1'; }
    } else if (state === 'paused') {
      morph.classList.add('expanded');
      if (pi) { pi.innerHTML = PLAY_SVG; pi.style.opacity = '1'; }
      if (eq) { eq.style.opacity = '0.5'; }
    } else {
      morph.classList.remove('expanded');
      if (pi) { pi.innerHTML = PLAY_SVG; pi.style.opacity = '1'; }
      if (eq) { eq.style.opacity = '0'; }
      if (sw) { sw.style.clipPath = 'inset(0 100% 0 0)'; }
    }
  }

  function currentKey() {
    var P = window.TRKVLTPlayer;
    if (!P || !P.hasStarted) { return ''; }
    var t = P.queue[P.currentIndex];
    return t && t.packUrlKey ? t.packUrlKey : '';
  }

  function keyOfCard(morph) {
    var card = cardOf(morph);
    var url = packUrlFromCard(card, morph);
    if (url) { return url; }
    return String(card && card.dataset ? (card.dataset.productId || '') : '');
  }

  function onPlayerUpdate(e) {
    var playing = !!(e.detail && e.detail.playing);
    var key = currentKey();
    if (!key) { return; }
    document.querySelectorAll('.bp-morph, .rel-morph').forEach(function (morph) {
      setMorphState(morph, keyOfCard(morph) === key ? (playing ? 'playing' : 'paused') : 'idle');
    });
  }

  function onPlayerProgress(e) {
    if (!e.detail || typeof e.detail.pct !== 'number') { return; }
    var key = currentKey();
    if (!key) { return; }
    document.querySelectorAll('.bp-morph, .rel-morph').forEach(function (morph) {
      if (keyOfCard(morph) !== key) { return; }
      var sw = morph.querySelector('.bp-sweep');
      if (sw) { sw.style.clipPath = 'inset(0 ' + (100 - e.detail.pct).toFixed(2) + '% 0 0)'; }
    });
  }

  function install() {
    window.playPackPreview = function (morphEl) { window.trkvltPlayPack(morphEl); };
    window.handleRecoPlayClick = function (btn) { window.trkvltPlayPack(btn); };

    window.removeEventListener('trkvltplayerupdate', onPlayerUpdate);
    window.removeEventListener('trkvltplayerprogress', onPlayerProgress);
    window.addEventListener('trkvltplayerupdate', onPlayerUpdate);
    window.addEventListener('trkvltplayerprogress', onPlayerProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }

  function patchPageInit() {
    if (typeof window.trkvltPageInit !== 'function') { setTimeout(patchPageInit, 250); return; }
    if (window._trkvltTracklistPatched) { return; }
    window._trkvltTracklistPatched = true;
    var orig = window.trkvltPageInit;
    window.trkvltPageInit = function () { orig(); install(); };
  }
  patchPageInit();
})();
